import React, { ElementType } from 'react';
import cn from 'classnames';
import {
  Button,
  createStyles,
  withStyles,
  Theme,
  ButtonProps,
} from '@material-ui/core';
import Routes from 'routes';

export interface FsButtonProps extends ButtonProps {
  minWidth?: number;
  whiteSpace?: boolean;
  component?: ElementType;
  to?: Routes;
}

const FsButton = withStyles(({ spacing }: Theme) =>
  createStyles({
    root: {
      borderRadius: spacing(1),
      padding: spacing(1.4, 4),
      textTransform: 'none',
      '&.whiteSpace': {
        whiteSpace: 'nowrap',
      },
    },
  })
)(({ minWidth, whiteSpace, style, ...otherProps }: FsButtonProps) => (
  <Button
    {...otherProps}
    style={{ ...style, minWidth }}
    className={cn({ whiteSpace })}
  />
));

export default FsButton;
